import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import { Toast } from '../../services';
import { API_URL } from '../../config/constants';
import HttpService from "../../config/http.service";

const ConfirmValidation = ({ data }: any) => {
    const { isOpenConfirm, setIsOpenConfirm, validationRule, setIsLoad } = data;

    const deleteValidation = () => {
        HttpService.deleteRequest(API_URL.DELETE_VALIDATION + "/" + validationRule.id).then(
            (res: any) => {
                setIsOpenConfirm(false);
                setIsLoad(true);
                Toast("Validation rule deleted successfully.", "success");
            },
            (err: any) => {
                Toast(err.message, "error");
            }
        )
    }

    return (
        <div className='custom-modal'>
            <Modal
                isOpen={isOpenConfirm}
                srLabelledBy={'modal-id-confirm-delete'}
                srDescribedBy={'modal-id-confirm-delete'}>
                <ModalHeader
                    titleId={'modal-id-confirm-delete'}
                    isFullscreenButtonVisible
                    onUserRequest={() => setIsOpenConfirm(false)}>
                    Confirm
                </ModalHeader>
                <ModalBody descriptionId="modal-id-confirm-delete">
                    Are you sure you want to delete this validation rule?
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'text'}>
                                <button
                                    type="button"
                                    id="cancel"
                                    onClick={() => setIsOpenConfirm(false)}>
                                    Cancel
                                </button>
                            </ButtonField>
                            <ButtonField>
                                <button
                                    type="button"
                                    id="defaultClose"
                                    onClick={() => deleteValidation()}>
                                    Delete
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ConfirmValidation;
